export type Monoid<A> = {
  zero: A
  append: (left: A, right: A) => A
}

export function concat<A>(monoid: Monoid<A>) {
  // eslint-disable-next-line func-names
  return function (xs: A[]): A {
    return xs.reduce(monoid.append, monoid.zero)
  }
}
